// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__rgKVu","navlinks":"Navbar_navlinks__gOSn0","btn":"Navbar_btn__pEEiL","logo":"Navbar_logo__9JNaS","align":"Navbar_align__4RjPW"};